import {
  MergeQueueBranchMode,
  MergeQueueResponse,
  MergeQueueStrategy,
} from 'src/components/settings/merge-queues/types';

export class MergeQueue {
  readonly uuid: string = '';
  readonly createdOn: string = '';
  readonly lastUpdatedOn: string = '';
  readonly name: string = '';
  readonly strategy: MergeQueueStrategy = MergeQueueStrategy.STRICT_PER_PR;
  readonly buildConcurrency: number = 0;
  readonly branch: {
    mode: MergeQueueBranchMode;
    name?: string;
    type?: string;
    pattern?: string;
  } = {
    mode: MergeQueueBranchMode.BRANCH_NAME,
    name: '',
    type: '',
    pattern: '',
  };
  readonly isFrozen: boolean = false;
  readonly maximumWaitTimeInSeconds: number = 0;
  readonly maximumPullRequestsInBatch?: number = undefined;
  readonly maximumBatchWaitTimeInSeconds?: number = 0;
  readonly minimumPullRequestsInBatch?: number = undefined;

  constructor(props: Partial<MergeQueueResponse> = {}) {
    Object.assign(this, {
      uuid: props.uuid,
      createdOn: props.created_on,
      lastUpdatedOn: props.last_updated_on,
      name: props.name,
      strategy: props.strategy,
      buildConcurrency: props.build_concurrency,
      branch: {
        mode: props.branch?.mode,
        name: props.branch?.name,
        type: props.branch?.type,
        pattern: props.branch?.pattern,
      },
      isFrozen: props.is_frozen,
      maximumWaitTimeInSeconds: props.maximum_wait_time_in_seconds,
      maximumBatchWaitTimeInSeconds: props.maximum_batch_wait_time_in_seconds,
      maximumPullRequestsInBatch: props.maximum_pull_requests_in_batch,
      minimumPullRequestsInBatch: props.minimum_pull_requests_in_batch,
    });
  }
}
